import React, { useState } from 'react';
import { LayoutDashboard, MessageSquare, TrendingUp, Bell, Lock, Shield } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { ChangePasswordModal } from '../../components/modals/ChangePasswordModal';
import { Setup2FAModal } from '../../components/modals/Setup2FAModal';
export function SettingsPage() {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [is2FAModalOpen, setIs2FAModalOpen] = useState(false);
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    inquiryAlerts: true,
    marketingEmails: false
  });
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries'
  }, {
    label: 'Performance',
    icon: TrendingUp,
    path: '/seller/performance'
  }];
  return <DashboardLayout title="Seller Console" personaLabel="SELLER" personaColor="bg-purple-100 text-purple-800 border-purple-200" navItems={navItems} userInitials="SK" data-id="element-5564">
      <h1 className="text-2xl font-bold mb-8" data-id="element-5565">Account Settings</h1>

      {/* Profile Section */}
      <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5566">
        <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-5567">
          Profile Information
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5568">
          <div data-id="element-5569">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5570">
              Full Name
            </label>
            <input type="text" defaultValue="Rajesh Kumar" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5571" />
          </div>
          <div data-id="element-5572">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5573">
              Email
            </label>
            <input type="email" defaultValue="rajesh@example.com" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5574" />
          </div>
          <div data-id="element-5575">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5576">
              Phone
            </label>
            <input type="tel" defaultValue="+91 98765 43210" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5577" />
          </div>
          <div data-id="element-5578">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5579">
              Location
            </label>
            <input type="text" defaultValue="Pune, Maharashtra" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5580" />
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-5581">
          <button className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5582">
            Save Changes
          </button>
        </div>
      </div>

      {/* Security Section */}
      <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5583">
        <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5584">
          <Shield className="w-5 h-5" data-id="element-5585" />
          Security
        </h2>
        <div className="space-y-4" data-id="element-5586">
          <div className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5587">
            <div data-id="element-5588">
              <div className="font-bold text-sm mb-1" data-id="element-5589">Password</div>
              <div className="text-xs text-gray-500" data-id="element-5590">
                Last changed 3 months ago
              </div>
            </div>
            <button onClick={() => setIsPasswordModalOpen(true)} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-white" data-id="element-5591">
              Change Password
            </button>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5592">
            <div data-id="element-5593">
              <div className="font-bold text-sm mb-1" data-id="element-5594">
                Two-Factor Authentication
              </div>
              <div className="text-xs text-gray-500" data-id="element-5595">
                Add extra security to your account
              </div>
            </div>
            <button onClick={() => setIs2FAModalOpen(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5596">
              Enable 2FA
            </button>
          </div>
        </div>
      </div>

      {/* Notification Preferences */}
      <div className="bg-white border border-gray-300 p-6" data-id="element-5597">
        <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5598">
          <Bell className="w-5 h-5" data-id="element-5599" />
          Notification Preferences
        </h2>
        <div className="space-y-4" data-id="element-5600">
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5601">
            <div data-id="element-5602">
              <div className="font-bold text-sm" data-id="element-5603">Email Notifications</div>
              <div className="text-xs text-gray-500" data-id="element-5604">
                Receive updates via email
              </div>
            </div>
            <input type="checkbox" checked={settings.emailNotifications} onChange={e => setSettings({
            ...settings,
            emailNotifications: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5605" />
          </label>
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5606">
            <div data-id="element-5607">
              <div className="font-bold text-sm" data-id="element-5608">SMS Notifications</div>
              <div className="text-xs text-gray-500" data-id="element-5609">
                Receive updates via SMS
              </div>
            </div>
            <input type="checkbox" checked={settings.smsNotifications} onChange={e => setSettings({
            ...settings,
            smsNotifications: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5610" />
          </label>
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5611">
            <div data-id="element-5612">
              <div className="font-bold text-sm" data-id="element-5613">New Inquiry Alerts</div>
              <div className="text-xs text-gray-500" data-id="element-5614">
                Get notified of new inquiries instantly
              </div>
            </div>
            <input type="checkbox" checked={settings.inquiryAlerts} onChange={e => setSettings({
            ...settings,
            inquiryAlerts: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5615" />
          </label>
          <label className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5616">
            <div data-id="element-5617">
              <div className="font-bold text-sm" data-id="element-5618">Marketing Emails</div>
              <div className="text-xs text-gray-500" data-id="element-5619">
                Receive tips and platform updates
              </div>
            </div>
            <input type="checkbox" checked={settings.marketingEmails} onChange={e => setSettings({
            ...settings,
            marketingEmails: e.target.checked
          })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5620" />
          </label>
        </div>
      </div>

      <ChangePasswordModal isOpen={isPasswordModalOpen} onClose={() => setIsPasswordModalOpen(false)} data-id="element-5621" />

      <Setup2FAModal isOpen={is2FAModalOpen} onClose={() => setIs2FAModalOpen(false)} data-id="element-5622" />
    </DashboardLayout>;
}